
import React from 'react';
import { Card, CardFooter } from "@/components/ui/card";
import { LucideIcon } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { ClinicalDetails, AdverseReactions } from '@/data/medications';
import MedicationCardHeader from './medications/MedicationCardHeader';
import MedicationCardContent from './medications/MedicationCardContent';

interface MedicationCardProps {
  name: string;
  description: string;
  research: string;
  url: string;
  Icon: LucideIcon;
  video?: string;
  clinicalDetails?: ClinicalDetails;
  availablePreparations?: string;
  adverseReactions?: AdverseReactions;
  category?: string;
}

const MedicationCard: React.FC<MedicationCardProps> = ({ 
  name, 
  description, 
  research, 
  url, 
  Icon, 
  video,
  clinicalDetails,
  availablePreparations,
  adverseReactions,
  category
}) => {
  const { isAuthenticated, isProviderView } = useAuth();
  
  return (
    <Card className="medication-card h-full flex flex-col">
      <MedicationCardHeader 
        name={name}
        Icon={Icon}
        availablePreparations={availablePreparations}
      />
      
      <MedicationCardContent
        name={name}
        description={description}
        research={research}
        url={url}
        video={video}
        isAuthenticated={isAuthenticated}
        isProviderView={isProviderView}
        clinicalDetails={clinicalDetails}
        availablePreparations={availablePreparations}
        adverseReactions={adverseReactions}
        category={category}
      />
      
      <CardFooter className="p-4 md:p-6 pt-0">
        {/* Footer content if needed */}
      </CardFooter>
    </Card>
  );
};

export default MedicationCard;
